module.exports = {
      id: "twitter_x2-usage",
      viewBox: "0 0 256 256",
      url: __webpack_public_path__ + "svg-sprite-147fd1e4cc1faf335e98b31c6ae31fe2.svg#twitter_x2",
      toString: function () {
        return this.url;
      }
    }